import { DiscussionComment } from '@models/recruiting/discussion-comment.model';
import { ModelMixin } from '../core/base-generic.model';

export class ApplicantDiscussion extends ModelMixin<ApplicantDiscussion>() {
    protected static _resource = 'applicantTracker/discussions';
    protected static _version = 'v2';
    protected static _type = 'applicantDiscussions';

    get name(): string {
        return this._attributes['name'];
    }

    get discussionComments(): DiscussionComment[] {
        return this.hasMany(DiscussionComment, 'comments');
    }

    set discussionComments(val: DiscussionComment[]) {
        this.setMany('comments', val);
    }
}
